import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { CaseStudiesListing } from './pages/CaseStudiesListing';
import { CaseStudyDetail } from './pages/CaseStudyDetail';
import { Book } from './pages/Book';
import { About } from './pages/About';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/casestudies" element={<CaseStudiesListing />} />
        <Route path="/casestudies/:slug" element={<CaseStudyDetail />} />
        <Route path="/book" element={<Book />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
}

export default App;
